module.exports = __webpack_public_path__ + "img/news32.3646b491.png";